module.exports = __webpack_public_path__ + "static/media/RulesforRuleBreakingBookCover.38d0f623.jpg";